import { Box, Container, Typography, Button } from "@mui/material"

interface HeroSectionProps {
  scrollToPlatform: any;
}

export default function HeroSection({ scrollToPlatform }: HeroSectionProps) {
  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        py: 10,
        textAlign: "center",
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="overline"
          sx={{
            fontWeight: 600,
            color: "primary.light",
            letterSpacing: 1.5,
            mb: 2,
            display: "block",
          }}
        >
          THE PYTHAVERSE <span style={{fontSize: "19px", textTransform: "math-auto"}}>EduEcoSystem</span>
        </Typography>

        <Typography
          variant="h1"
          sx={{
            maxWidth: "800px",
            mx: "auto",
            mb: 3,
          }}
        >
          Your Advantage in the Classroom and Your Career.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            maxWidth: "750px",
            mx: "auto",
            mb: 5,
            color: "#444",
            fontWeight: 400,
            "& strong": {
              color: "text.primary",
            },
          }}
        >
          A complete platform where you can <strong>Master</strong> new skills in expert workshops,{" "}
          <strong>Connect</strong> with a global network of peers, and <strong>Lead</strong> the future of education
          through groundbreaking challenges.
        </Typography>

        <Button variant="contained" color="primary" size="large" onClick={scrollToPlatform}>
          Explore the EcoSystem
        </Button>
      </Container>
    </Box>
  )
}
